import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { deleteProject, getProjectById } from "../../services/api"; // Funciones para eliminar y obtener el proyecto

const ProjectDelete = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = React.useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await getProjectById(id);
        setProject(response.data);
      } catch (error) {
        console.error("Error al obtener el proyecto", error);
      }
    };

    fetchProject();
  }, [id]);

  const handleDelete = async () => {
    try {
      await deleteProject(id);
      navigate("/dashboard/projects"); // Redirige a la lista de proyectos después de la actualización
    } catch (error) {
      console.error("Error al eliminar el proyecto", error);
    }
  };

  return (
    <>
      <h2>Eliminar Proyecto</h2>
      {project ? (
        <div>
          <p>
            ¿Estás seguro que deseas eliminar el proyecto{" "}
            <strong>{project.nombre}</strong>?
          </p>
          <button className="btn btn-danger" onClick={handleDelete}>
            Eliminar
          </button>
          <button
            className="btn btn-secondary ms-3"
            onClick={() => navigate("/projects")}
          >
            Cancelar
          </button>
        </div>
      ) : (
        <p>Cargando detalles del proyecto...</p>
      )}
    </>
  );
};

export default ProjectDelete;
